export const AFFILIATION_TYPE = {
  NON_AFFILIATED: 0,
  ATM_AFFILIATION: 1,
  ATL_AFFILIATION: 2
};
